import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin, Tabs } from 'antd';
import {SearchOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import UPM from '../../constants/urlPermissionMappings'
import {PAGE_SIZE_DEFAULT} from '../../constants/appConstant'
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
const storage = window.localStorage
const { TabPane } = Tabs;

@inject('marketingSmsTemplateStore', 'accountStore')
@observer
class MarketingSmsTemplate extends Component {
  state = {
    type: "1",
  }
  componentDidMount() {
    const {marketingSmsTemplateStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.handleSearch(this.state.type)
    marketingSmsTemplateStore.onGetGroup({
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
    })
    marketingSmsTemplateStore.onGetStatus('templateStatus')
    marketingSmsTemplateStore.onGetSign({
      templateType: this.state.type,
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
    })
  }
  handleSearch = (type) => {
    const {marketingSmsTemplateStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    marketingSmsTemplateStore.onSearchAction({
      templateType: type,
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
      page: 1, 
      size: PAGE_SIZE_DEFAULT
    })
  }
  onChange = (value) => {
    this.setState({
      type: value
    })
    this.handleSearch(value)
  }
  render() {
    const { marketingSmsTemplateStore,location, t } = this.props
    const { isFetching } = marketingSmsTemplateStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <div className="searchFormTitle" style={{background: 'white', padding: '0 15px'}}>
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Tabs defaultActiveKey="1" onChange={this.onChange} className='messagesTabs marketingSmsTemplateTabs'>
            <TabPane tab={t(`marketingManagement.marketingSmsTemplate`)} key="1">
              <SearchForm type={this.state.type} />
              <SearchResult type={this.state.type} />
            </TabPane>
            <TabPane tab={t(`marketingManagement.noticeSmsTemplate`)} key="2">
              <SearchForm type={this.state.type} />
              <SearchResult type={this.state.type} />
            </TabPane>
          </Tabs>
        </div>
      </Spin>
    );
  }
}
export default withTranslation()(MarketingSmsTemplate)
